import { Component, OnInit, ViewChild } from "@angular/core";
import {
  Cell,
  Page,
  PageLayout,
  Template,
  TemplatePageKind,
  TemplatePage,
  Catalog,
} from "@app/data/catalog";
import { PAGE_LAYOUT_API_URL, TEMPLATE_API_URL } from "@app/data/const";
import { RemoteDataService } from "@nowinstore/nowinstore-core-ui/components";
import { ThemeCreatorService } from "./theme-creator.service";
import { CatalogPageComponent } from "./catalog-page.component";

@Component({
  selector: "app-catalog-template",
  templateUrl: "./catalog-template.component.html",
})
export class CatalogTemplateComponent implements OnInit {
  editorOptions = { theme: "vs-dark", language: "html" };
  template: string = "";
  _code: string = "";
  activeTab: number = 1;
  templateOptions: any[] = [
    {
      value: TemplatePageKind.FrontCover,
      label: "Front Cover",
    },
    {
      value: TemplatePageKind.BackCover,
      label: "Back Cover",
    },
    {
      value: TemplatePageKind.TableOfContents,
      label: "Table of Contents",
    },
    {
      value: TemplatePageKind.WholesaleContract,
      label: "Wholesale Contract",
    },
    {
      value: TemplatePageKind.WholesaleForm,
      label: "Wholesale Form",
    },
  ];
  templateTags: { value: string; name: string }[] = [
    { value: "wholesale", name: "Wholesale" },
    { value: "retail", name: "Retail" },
  ];
  templates: Template[] = [];
  _selectedTemplate: Template;
  layouts: PageLayout[] = [];
  isSidebarVisible: boolean;
  _selectedPage: Page;
  @ViewChild("pageComponent")
  catalogPageComponent: CatalogPageComponent;

  constructor(
    private remoteDataService: RemoteDataService,
    private themeCreatorService: ThemeCreatorService
  ) {}

  async ngOnInit() {
    this.templates = await this.remoteDataService.query<Template>(
      TEMPLATE_API_URL
    );
    this.layouts = await this.remoteDataService.query<PageLayout>(
      PAGE_LAYOUT_API_URL
    );
  }

  addTemplate() {
    this.selectedTemplate = {
      title: "New Template",
      pages: [],
      tags: [],
    };
  }

  addPage() {
    const newPage: TemplatePage = {
      layout: "<n-container></n-container>",
      kind: TemplatePageKind.FrontCover,
    };
    this.selectedTemplate.pages.push(newPage);
  }

  deletePage() {
    this.selectedTemplate.pages = this.selectedTemplate.pages.filter(
      (page) => page !== this.selectedPage
    );
    this.selectedPage = null;
  }

  set selectedTemplate(template: Template) {
    this._selectedTemplate = template;
    this.selectedPage =
      this._selectedTemplate?.pages.length > 0
        ? this._selectedTemplate.pages[0]
        : null;
  }

  get selectedTemplate(): Template {
    return this._selectedTemplate;
  }

  set selectedPage(page: Page) {
    this._selectedPage = page;
    this.code = <string>page.layout;
    this.isSidebarVisible = true;
  }

  get selectedPage(): Page {
    return this._selectedPage;
  }

  set code(code: string) {
    this._code = code;
    if (this.selectedPage) {
      Object.assign(this.selectedPage, { layout: code });
      if (this.catalogPageComponent) {
        this.catalogPageComponent.refresh();
      }
    }
  }

  get code(): string {
    return this._code;
  }

  async save() {
    if (!this.selectedTemplate._id) {
      this.selectedTemplate = await this.remoteDataService.post<Template>(
        TEMPLATE_API_URL,
        this.selectedTemplate
      );
    } else {
      this.selectedTemplate = await this.remoteDataService.put<Template>(
        TEMPLATE_API_URL,
        this.selectedTemplate._id,
        this.selectedTemplate
      );
    }
    this.templates = await this.remoteDataService.query<Template>(
      TEMPLATE_API_URL
    );
  }
}
